import { getImageUrlFromName } from '../../../util'

const HotelSeparatorLayout = ({ layout, value }) => {
  return (
    <>
      {layout.display_name === 'Things to know' && (
        <div
          style={{
            padding: '24px 20px 0px 20px',
            background: layout.color ? `#${layout.color}` : '',
            //  background: '#0000ff',
          }}
        >
          {/* <div>
        <img src={imageUrl} alt="" />
      </div> */}
          <div
            style={{
              marginTop: '10px',
              marginBottom: '10px',
              textAlign: 'left',
              listStyle: 'none',
              color: 'var(--gray100)',
            }}
          >
            <p className="title1">{layout.display_name}</p>
          </div>
        </div>
      )}
    </>
  )

  // Non needed in web since we are not shwoing components
  /*
    let imageUrl =  getImageUrlFromName(layout.icon_name)
    console.log("iconName : " + layout.icon_name + " imageUrl : " + imageUrl)

    return (
      <div
        style={{
          padding: '16px 24px 32px 24px',
           background: layout.color ? `#${layout.color}` : '',
         //  background: '#0000ff',
        }}
      >
        <div>
        <img src={imageUrl} alt="" />
        </div>
        <div
          style={{
            marginTop: '10px',
            marginBottom: '10px',
            textAlign: 'left',
            listStyle: 'none',
            color: 'var(--gray100)',
          }}
        >
          <p className="title1">
          {layout.display_name}
          </p>
        </div>
      </div>
    )
    */
}
export default HotelSeparatorLayout
